import React, { useEffect, useState } from 'react';
import { Box, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { isAccessTokenValid, refreshAccessToken } from '../../../authSession';

const ProtectedRoute = ({ children }) => {
  const user = useSelector((state) => state.user);
  const permissions = useSelector((state) => state.permissions);
  const shouldRecover = Boolean(user && permissions && !isAccessTokenValid(user.accessToken));
  const [isRecovering, setIsRecovering] = useState(shouldRecover);

  useEffect(() => {
    if (!shouldRecover) {
      setIsRecovering(false);
      return undefined;
    }

    let active = true;
    setIsRecovering(true);
    refreshAccessToken()
      .catch(() => undefined)
      .finally(() => {
        if (active) setIsRecovering(false);
      });

    return () => {
      active = false;
    };
  }, [shouldRecover]);

  if (!user || !permissions) return <Navigate replace to="/login" />;

  if (isRecovering) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
        <CircularProgress aria-label="Restoring session" />
      </Box>
    );
  }

  return children;
};

export default ProtectedRoute;
